<script setup lang="ts">
import { Form } from 'vee-validate'
import BaseInput from '~/components/common/base-input.vue'
import BaseButton from '~/components/common/base-button.vue'
import { useContact } from '~/composables/common/use-contact'
import { useCommon } from '~/composables/common/use-common'
import { useUpdateProfile } from '~/composables/account/use-update-profile'
import { updateDisplaynameSchema } from '~/validate/forms/update-profile'
import { AUTH_CRITERIA } from '~/validate/constant/auth'
import UserIcon from '~/assets/images/icons/user-icon.svg'

const { user, handleSubmit, resetError, messageError } = useUpdateProfile({ isDisplayNameOnly: true })
const { telegramSupport } = useContact()
const { openLiveChat } = useCommon()
</script>

<template>
  <Form
    v-slot="{ isSubmitting, meta: { valid } }"
    name="form-info-personal"
    :validationSchema="updateDisplaynameSchema"
    @submit="handleSubmit"
  >
    <div class="form__update-display-title">TÊN HIỂN THỊ KHÔNG HỢP LỆ</div>
    <div class="form__update-display-sub-title">Vui lòng tạo mới tên hiển thị để sử dụng chơi game</div>

    <BaseInput
      v-model="user.fullname"
      name="fullname"
      label="Tên hiển thị"
      isLabelFloating
      :iconPrepend="UserIcon"
      :errorCustom="messageError"
      :maxLength="AUTH_CRITERIA.FULL_NAME_MAX_LENGTH"
      @input="resetError"
    />

    <div class="form__btn-login">
      <BaseButton
        type="submit"
        size="extra-large"
        :disable="isSubmitting || !valid || messageError !== ''"
        :isLoadingButton="isSubmitting"
      >
        Cập nhật
      </BaseButton>
    </div>

    <div class="form__help" :href="telegramSupport?.link" @click="openLiveChat">
      <span class="live-chat"></span>
      <span>Live Chat</span>
    </div>
  </Form>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/auth/form-auth.scss';
</style>
<style scoped lang="scss">
:deep(.base-input:has(.error) .base-input__wrap) {
  margin-bottom: 32px;
}
</style>
